module.exports = __webpack_public_path__ + "img/classify-item2.23508361.png";